module.exports = __webpack_public_path__ + "static/media/colorBridging2.5872d9b5.jpg";